<div *ngIf="shouldShowAlert()" class="subscription-alert-container">
  <div class="subscription-alert">
    <div class="flex items-center justify-between flex-wrap gap-3">
      <div class="flex items-center gap-3">
        <i class="pi pi-exclamation-triangle text-xl"></i>
        <div>
          <span class="font-semibold">Your account is on hold.</span>
          <span class="ml-1">Please renew your subscription to continue using all features.</span>
        </div>
      </div>
      <button
        pButton
        type="button"
        label="Renew Subscription"
        icon="pi pi-refresh"
        (click)="onRenewSubscription()"
        [loading]="isProcessingPayment"
        [disabled]="isProcessingPayment"
        class="p-button-sm p-button-warning"
      ></button>
    </div>
  </div>
</div>

<p-confirmDialog />
<p-toast />
